import React, { useEffect, useState } from "react";
import {
  Button,
  Grid ,
  Card,
  CardContent,
  TextField ,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getRequest } from "../../utils/GetRequest";
import { approveRequest, rejectRequest, resubmitRequest, reopenRequest } from "../../utils/PostRequest";
import requestMissingContexts, { determineConfig  } from "../../utils/GetContext";
import {checkForRole} from "../../utils/GetAuth";
import PageInPage from "../../componentUtils/PageInPage";
import { removeLeadingZeros, formatDate } from "../../utils/Formatter";
import RecommendationComponent from "../../components/request/Recommend";
import CardChangeSummary from "../../components/request/CardChangeSummary";
import CardKPI from "../../components/request/CardKPI";
import CardCustomerLocation from "../../components/request/CardCustomerLocation";
import ButtonDownloadPDF from "../../components/request/ButtonDownloadPDF"

import {
  Lock,
  ThumbDown,
  ThumbUp,
  Publish,
  Edit,
 } from '@mui/icons-material';
import { GetAllMaterialText, materialText } from "../../utils/GetAML"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    bottomButtons:{
      textAlign: "center",
      padding:  theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(2),
    },
    root: {
    },
    divWidth: {
      width: "100%",
    },
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    downTrend:{
      color: theme.palette.statusRed.main,
    },
    upTrend: {
      color: theme.palette.statusGreen.main,
    },
    cellChanged:{
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    cell:{
    },
    cards:{
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function VendPrimeRequest(props:{requestNum:number,onClose?:Function}) {
  const classes = useStyles();
  const requestNum = props.requestNum;
  const [vpRequest, SetVpRequest] = useState<any>();
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [confirmDialog, setConfirmDialog] = React.useState<boolean>(false);
  const [dialogMessage, setDialogMessage] = React.useState<any>({code:0,message:""})
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_access');
  const approver = checkForRole(`${clientId}`,salesOrg,'vp_approve_ticket');
  const [materialTexts,setMaterialTexts] = useState<materialText[]>([]);
  const [displayPIP, setDisplayPIP] = React.useState<boolean>(false);


  
  /***
   * Request internal status order. 
   * Used to enforce that a ticket can only be resubmitted if it was canceled 
   * @param {string} curStatus - The current status of the request
   */
  const isCancelStatus = (curStatus:string) => {
    const REQ_CANCEL_LIST:string[] = ['C','Z','!','VP_REJECT']
    return REQ_CANCEL_LIST.findIndex(rcl => rcl === curStatus) >= 0
  }

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES","vp_req_status"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        getRequest(salesOrg,requestNum).then((v) => {
          if(v ){
            SetVpRequest(v);
          }
          GetAllMaterialText()
          .then((v) => {
            if(v && v.materialTxt) setMaterialTexts(v.materialTxt)
            setDoneLoading(true);
          })
        });
      });
  }, [ vpRequest, confirmDialog, displayPIP, doneLoading, salesOrg, requestNum]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled && vpRequest? (
        <div>
          <Grid container spacing={2} className={classes.gridMarginTop}>
            <Grid
              item
              xs={12}
              lg={8}
              className={classes.gridSpaceable}
            >
              <CardCustomerLocation mdCustomer={vpRequest.request.mdCustomer}/>
          </Grid>
          {(vpRequest.request.txReqReconfigKpi && vpRequest.request.txReqReconfigKpi.length > 0)?(
            <Grid
              item
              xs={12}
              lg={4}
              className={classes.gridSpaceable}
            >
            <CardKPI kpis={vpRequest.request.txReqReconfigKpi} />
          </Grid>
          ):(<div></div>)}
          {(vpRequest.request)?(
            <Grid
              item
              xs={12}
              lg={12}
              className={classes.gridSpaceable}
            >
              <Card className={classes.cards}>
                <CardContent>
                  <Grid container spacing={2} className={classes.gridMarginTop}>
                    <Grid
                        item
                        xs={6}
                        lg={4}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        label="Status"
                        value={determineConfig(codes, "vp_req_status", vpRequest.request.requestStatus)}
                        defaultValue={determineConfig(codes, "vp_req_status", vpRequest.request.requestStatus)}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        label="Method"
                        value={vpRequest.request.optimizationPackMethod}
                        defaultValue={vpRequest.request.optimizationPackMethod}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        label="Type"
                        value={vpRequest.request.optimizationType}
                        defaultValue={vpRequest.request.optimizationType}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        label="Requested On"
                        value={formatDate(vpRequest.request.requestedDt)}
                        defaultValue=""
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        label="Requested By"
                        value={vpRequest.request.requestedBy}
                        defaultValue={vpRequest.request.requestedBy}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={2}
                        lg={1}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        onClick={()=>setDisplayPIP(true)}
                        label="Request Number"
                        value={vpRequest.request.requestNum}
                        defaultValue={vpRequest.request.requestNum}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        label="SAP Ticket Number"
                        contentEditable={false}
                        value={removeLeadingZeros(vpRequest.request.sapRequestNumber||"")}
                        defaultValue={removeLeadingZeros(vpRequest.request.sapRequestNumber||"")}
                        InputProps={{readOnly: true,}}
                      />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        lg={2}
                        className={classes.gridSpaceable}
                      >
                      <TextField
                        fullWidth={true}
                        contentEditable={false}
                        type="datetime"
                        label="PDF Sent"
                        value={(vpRequest.request.pdfEmailDt)?formatDate(vpRequest.request.pdfEmailDt):""}
                        defaultValue=""
                        InputProps={{readOnly: true,}}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={4}
                        lg={4}
                        className={classes.gridSpaceable}
                      >
                        {(approver && vpRequest.request.requestStatus === "VP_QUEUE")?(
                          <div>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.button}
                              onClick={() => {approveRequest(salesOrg,requestNum,'pending').then((r)=>{setDialogMessage(r); setDoneLoading(false); setConfirmDialog(true)});}}
                              ><ThumbUp style={{marginRight:"5px"}}/>Approve</Button>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.button}
                              onClick={() => {rejectRequest(salesOrg,requestNum).then((r)=>{setDialogMessage(r); setDoneLoading(false); setConfirmDialog(true)});}}
                              ><ThumbDown style={{marginRight:"5px"}}/>Reject</Button>
                          </div>
                        ):(<div></div>)}
                        {(approver && isCancelStatus(vpRequest.request.requestStatus))?(
                          <div>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.button}
                              onClick={() => {reopenRequest(salesOrg,requestNum).then((r)=>{setDialogMessage(r); setDoneLoading(false); setDisplayPIP(true);});}}
                              ><Edit style={{marginRight:"5px"}}/>Re-Open</Button>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.button}
                              onClick={() => {resubmitRequest(salesOrg,requestNum).then((r)=>{setDialogMessage(r); setDoneLoading(false); setConfirmDialog(true)});}}
                              ><Publish style={{marginRight:"5px"}}/>Re-Submit</Button>
                          </div>
                        ):(<div></div>)}
                        <ButtonDownloadPDF 
                              salesOrg={salesOrg} 
                              requestNum={requestNum} 
                              requestStatus={vpRequest.request.requestStatus} 
                              />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ):(<div></div>)}

        </Grid>
        {(vpRequest.mat_sum && vpRequest.mat_sum.length > 0)?(
          <CardChangeSummary mat_sum={vpRequest.mat_sum} material_text={materialTexts} />
          ):(<div></div>)}
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><Lock/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Vend Prime</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      <Dialog
        open={confirmDialog}
        onClose={()=>{setConfirmDialog(false)}}
      >
        <DialogTitle>{((dialogMessage?.status||500)>400)?"Error":"Success"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {(dialogMessage?.data?.message||"").toString()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setConfirmDialog(false); if(props.onClose)props.onClose();}} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
      {(vpRequest)?(
        <PageInPage 
          onClose={()=>{setDisplayPIP(false); if(props.onClose)props.onClose();}} 
          title={`
            ${vpRequest.request.mdCustomer.salesOffice||""} 
            (${vpRequest.request.mdCustomer.customerNum||""}) 
            ${vpRequest.request.mdCustomer.name1||""}
            ::: VPR:${vpRequest.request.requestNum}
             Ticket:${removeLeadingZeros(vpRequest.request.sapRequestNumber||"")}
            `}
          isOpen={displayPIP} 
          content={(
            <RecommendationComponent
              fullpage={false}
              customer={vpRequest.request.mdCustomer.customerNum}
              requestNum={vpRequest.request.requestNum}
            />)} 
        />):(<div></div>)}
    </div>
  );
}